import { useEffect } from 'react';
import listener from '../core/classes/StudyLoadingListener';

const { StudyLoadingListener } = listener;

const StudyLoadingMonitor = ({ studies }) => {
  useEffect(() => {
    const studyLoadingListener = StudyLoadingListener.getInstance();

    if (studies && studies.length > 0) {
      studyLoadingListener.clear();
      studyLoadingListener.addStudies(studies);
    }

    return () => {
      studyLoadingListener.clear();
    };
  }, [studies]);

  return null;
};

export default StudyLoadingMonitor;
